import { useState } from 'react'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'

import ModalBulkTransactions from './ModalBulkTransactions'

const Buttons = (): JSX.Element => {
  const [showBulkTransactions, showBulkTransactionsSet] = useState<boolean>(false)

  return (
    <>
      <button
        className="px-3 py-1 mx-1 border rounded-md border-primary text-primary"
        onClick={() => showBulkTransactionsSet(true)}
        type="button"
      >
        <Icon icon={faPlus} className="mr-2" />
        <span className="tracking-wider font-light">Bulk Transactions</span>
      </button>

      <ModalBulkTransactions
        title="Add Merchant Bulk Transactions"
        open={showBulkTransactions}
        onClose={() => showBulkTransactionsSet(false)}
      />
    </>
  )
}

export default Buttons
